<div class="container grid_2_home">
    <header>
    </header>
    <nav>
    </nav>
    <main>
        <h1>Not found</h1>
        <button routerLink='/home'>Return Home</button>
    </main>
</div>